function normalizedName(name) {
  return String(name || '')
    .trim()
    .replace(/\s+/g, ' ')
}

export function studentDisplayName(student = {}) {
  const safeStudent = student || {}
  const fullName = normalizedName(safeStudent.fullName || safeStudent.full_name)
  const preferredName = normalizedName(safeStudent.preferredName || safeStudent.preferred_name)

  if (!preferredName) return fullName
  if (!fullName) return preferredName
  if (preferredName.toLowerCase() === fullName.toLowerCase()) return fullName

  const [, ...remainingFullName] = fullName.split(' ')
  if (remainingFullName.length === 0) return preferredName

  const lastFullNamePart = remainingFullName[remainingFullName.length - 1].toLowerCase()
  const lastPreferredNamePart = preferredName.split(' ').pop().toLowerCase()
  if (lastPreferredNamePart === lastFullNamePart) return preferredName

  return `${preferredName} ${remainingFullName.join(' ')}`
}

export function hasDistinctStudentLegalName(student = {}) {
  const safeStudent = student || {}
  const fullName = normalizedName(safeStudent.fullName || safeStudent.full_name)
  const displayName = studentDisplayName(safeStudent)

  return Boolean(fullName && displayName && fullName.toLowerCase() !== displayName.toLowerCase())
}
